import { Box  } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const FullBleedSection = ({
	children,
	...props
}: PropsWithChildren<BoxProps>) => {
	return (
		<Box as="section" {...props}>
			{children}
		</Box>
	);
}
;
